export const callsChartsStyles = {
  container: 'flex flex-col relative w-full h-auto bg-moon-100',
  header:
    'bg-moon-50 border-b border-moon-250 pt-7 pr-16 pb-8 pl-16 shadow-sm shrink-0',
  headerContent: 'flex items-center justify-between',
  headerLeft: 'flex items-center gap-8',
  headerText: 'text-sm font-semibold text-moon-700',
  headerSubtext: 'text-sm font-medium text-moon-500',
  headerCount: 'text-xs text-moon-700 bg-moon-200 py-2 px-4 rounded',
  chartsContainer:
    'flex flex-col gap-12 overflow-x-hidden overflow-y-visible p-12',
  emptyState:
    'flex items-center justify-center text-moon-450 text-[14px] w-full min-h-[200px] text-center py-[40px] px-[20px]',
} as const;
